import '../common/css/common.less';
import "./css/twapp.less";
import '../common/angular-locale_sv-se.js';

require('../common/twshared');

require("./app");
//require("./debug");
//require('./react/examples/init');

require("./react/loadComponents");

require("./directives/comboDirective");
require("./directives/ergoDatepicker");
require("./directives/ergoTable");
require("./directives/ergoCheckbox");
require('./directives/ergoCheckgroup');
require("./directives/durationFilter");
require("./directives/ergoFilters");
require("./directives/ergoSelectText");
require("./directives/ergoValidation");
require("./directives/ergoFilterPanel");
require("./directives/ergoParsers");
require("./directives/ergoAdvancedSearch");
require("./directives/ergoScroll");
require("./directives/ergoYearmonth");
require("./directives/ergoMunicipalityCodeList");
require("./directives/ergoFileInput");

require("./components/auditlog/auditlogComponent");

require("./services/downloadService");
require("./services/browserService");
require("./services/filterBuilder");
require("./services/DialogControllerBase");
require('./services/tromanServer');
require('./services/tromanErrorParser');

require("./lists/ListBuilderController");
require("./lists/ListConfiguration");
require("./lists/listService");

require("./misc/Metadata");
require("./misc/ObjectCache");

require("./dialogs/dialogService");
require("./dialogs/EmailListController");

require("./sortDialog/sortDialog");
require("./sortDialog/SorterController");
require("./sortDialog/GroupSortController");

require("./front/FrontController");
require("./navbar/NavbarController");

require("./profile/ProfileController");

require("./persons/PersonsController");
require("./persons/PersonState");
require("./persons/PersonController");
require("./persons/PersonEditController");
require("./persons/PersonFilesController");
require("./persons/PersonMissionsController");
require("./persons/PersonEquipmentController");
require("./persons/PersonAwardsController");
require("./persons/personArchive/personArchive");
require("./persons/personArchive/PersonArchiveController");

require("./equipment/EquipmentEditController");

require("./awards/AwardEditController");

require("./system/SystemSettingsController");

require("./politikerSettings/PolitikerSettingsController");

require("./missions/MissionEditController");
require("./missions/MissionUpdateController");
require("./missions/MissionListController");

require("./missionTypes/MissionTypesController");
require("./missionTypes/MissionTypeEditController");

require("./parties/PartiesController");
require("./parties/PartyEditController");

require("./divisions/DivisionEditController");
require("./divisions/DivisionsController");

require("./organizations/organizationService");
require("./organizations/OrganizationState");
require("./organizations/OrganizationController");
require("./organizations/OrganizationEditController");
require("./organizations/OrganizationFilesController");
require("./organizations/OrganizationMissionsController");
require("./organizations/OrganizationsController");

require("./mandate/MandateEditController");

require("./organizationType/OrganizationTypeEditController");
require("./organizationType/OrganizationTypesController");

require("./meetings/form/MeetingFormComponent");

require("./meetings/detail/MeetingState");
require("./meetings/detail/MeetingController");
require("./meetings/detail/MeetingEditController");
require("./meetings/detail/MeetingFilesController");
require("./meetings/detail/MeetingMessagesController");
require("./meetings/detail/AttendanceController");
require("./meetings/detail/AttendanceDialogComponent");
require("./meetings/detail/PayrollController");

require("./meetings/search/RootMeetingsController");
require("./meetings/search/MeetingsShared");
require("./meetings/search/RegularMeetingsController");
require("./meetings/search/MeetingsToHandleController");
require("./meetings/search/CeremonyMeetingsController");
require("./meetings/search/PendingMeetingsController");

require("./meetings/timereport/TimeReportDialogController");

require("./meetings/ceremony/CeremonyController");
require("./meetings/ceremony/attach/AttachCeremonyComponent");
require("./meetings/ceremony/attach/MeetingFinderComponent");
require("./meetings/ceremony/convert/ConvertCeremonyComponent");
require("./meetings/ceremony/dialog/CeremonyDialogController");

require("./reports/reportOptions");
require("./reports/ReportDialogController");
require("./reports/ReportsController");
require("./reports/reportService");

require("./wageType/WageTypeEditController");
require("./wageType/WageTypesController");

require("./wageCalculation/WageCalculationEditController");
require("./wageCalculation/WageCalculationsController");

require("./wageGroup/WageGroupsController");
require("./wageGroup/WageGroupState");
require("./wageGroup/WageGroupController");
require("./wageGroup/WageGroupDetailsController");
require("./wageGroup/WageGroupOrganizationsController");
require("./wageGroup/WageGroupTransactionsController");
require("./wageGroup/WageGroupHistoryController");

require("./missionGroups/MissionGroupState");
require("./missionGroups/MissionGroupController");
require("./missionGroups/MissionGroupDetailsController");
require("./missionGroups/MissionGroupMissionsController");
require("./missionGroups/MissionGroupsController");
require("./missionGroups/UpdateMissionGroupController");

require("./payroll/editor/PaymentEditor");
require("./payroll/groupDialog/GroupDialogController");
require("./payroll/PayslipComponent");
require("./payroll/PayslipListComponent");
require("./payroll/paymentsList/PaymentsListComponent");
require("./payroll/proposed/ProposedRemunerationComponent");
require("./payroll/proposedTime/ProposedTimeComponent");
require("./payroll/simple/SimpleRemunerationComponent");
require("./payroll/complex/ComplexRemunerationComponent");

require('./pendingCertification/PendingCertificationController');